import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { fetchContactPeopleByLeadIds, fetchContactPeopleByProspectQuery } from '../../api/contactPeopleApi';

import { contactPeopleKeys } from './keys';

export const contactPeopleByLeadIdsOptions = (leadIds) =>
	queryOptions({
		queryKey: contactPeopleKeys.byLeadIds(leadIds),
		queryFn: async () => {
			const { data, error } = await fetchContactPeopleByLeadIds(leadIds);
			if (error) throw error;
			return data ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
	});

export function useContactPeopleByLeadIds(leadIds) {
	const enabled = Array.isArray(leadIds) && leadIds.length > 0;
	return useQuery({
		...contactPeopleByLeadIdsOptions(leadIds),
		enabled,
		select: (contacts) => {
			const contactMap = contacts.reduce((m, c) => {
				if (!m[c.companyId]) m[c.companyId] = [];
				m[c.companyId].push(c);
				return m;
			}, {});

			return {
				contacts,
				contactMap,
				contactIds: contacts.map((c) => c.id),
			};
		},
	});
}

export const contactPeopleByProspectQueryOptions = (prospectQueryId) =>
	queryOptions({
		queryKey: contactPeopleKeys.byProspectQuery(prospectQueryId),
		queryFn: async () => {
			const { data, error } = await fetchContactPeopleByProspectQuery(prospectQueryId);
			if (error) throw error;
			return data ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
	});

export function useContactPeopleByProspectQuery(prospectQueryId) {
	const enabled = Boolean(prospectQueryId);
	return useQuery({
		...contactPeopleByProspectQueryOptions(prospectQueryId),
		enabled,
	});
}
